import { LayoutPanelTop } from "lucide-react";
import { cn } from "@/lib/utils";

interface PanelThumbnailProps {
  url?: string | null;
  alt?: string;
  className?: string;
}

const PanelThumbnail = ({ url, alt, className }: PanelThumbnailProps) => {
  if (url) {
    return (
      <img
        src={url}
        alt={alt ?? "panel preview"}
        className={cn(
          "h-12 w-20 flex-shrink-0 rounded-md border border-neutral-800 bg-neutral-900 object-cover",
          className,
        )}
        loading="lazy"
      />
    );
  }
  return (
    <div
      className={cn(
        "flex h-12 w-20 flex-shrink-0 items-center justify-center rounded-md border border-neutral-800 bg-neutral-900 text-neutral-600",
        className,
      )}
    >
      <LayoutPanelTop className="h-5 w-5" />
    </div>
  );
};

export default PanelThumbnail;
